var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4464 12.9593L38.7852 12.9593L38.7852 27.8496L24.1077 27.8496L24.1077 12.1927L29.2884 1.69907L35.3967 1.69907L30.5498 11.5166L29.8375 12.9593L31.4464 12.9593ZM9.20989 12.9593L16.5486 12.9593L16.5486 27.8496L1.87117 27.8496L1.87118 12.1927L7.05185 1.69907L13.1601 1.69907L8.31321 11.5166L7.60096 12.9593L9.20989 12.9593Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote02);
export default __webpack_public_path__ + "static/media/quote02.25413344ecd2c2cf143b2220df0bf632.svg";
export { ForwardRef as ReactComponent };